import { gql } from '../../../artifacts/gql';

export const deleteAddressMutation = gql(`
  mutation webDeleteAddressMutation($input: AddressDeleteInput!) {
    addressDelete(input: $input) {
      successful
      messages {
        message
        code
        field
      }
    }
  }
`);
